/*!
 * hf-klaviyo-signup.js — makes Klaviyo authoritative for Shopify signup forms.
 *
 * The footer form (#footer-subscribe) and the Countdown to Kickoff form
 * (#ctk-newsletter) are stock Shopify customer forms that POST to /contact.
 * Those only reach Klaviyo if the Shopify -> Klaviyo sync behaves, they cannot
 * carry a signup-source property, and they were the cause of orphaned signups
 * found in Aug 2026.
 *
 * This subscribes the address to the HitchFire list directly first, then lets
 * the normal Shopify POST continue so the tagged Shopify customer still exists.
 * Same pattern hf-persona-gate.js already uses. Delete this file to revert.
 *
 * Matches ANY /contact customer form, including ones added later.
 *
 * Also subscribes the theme's email popup (sections/email-popup.liquid,
 * form[data-email-form]). That form is not a /contact form: hitchfire.js only
 * calls _learnq identify and shows the success panel, which subscribes nobody.
 */
(function () {
  'use strict';

  var COMPANY_ID = 'Sn3eGA';
  var LIST_ID = 'QZiq2A';
  var REVISION = '2024-10-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
  var FAILSAFE_MS = 1200;

  function sourceFor(form) {
    var id = (form.id || '').toLowerCase();
    if (id.indexOf('footer') > -1) return 'Footer signup';
    if (id.indexOf('ctk') > -1) return 'Countdown to Kickoff';
    return 'Site signup';
  }

  function isSignupForm(form) {
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/contact') === -1) return false;
    var ft = form.querySelector('input[name="form_type"]');
    if (ft && ft.value !== 'customer') return false;
    return !!form.querySelector('input[name="contact[email]"]');
  }

  function subscribe(email, source, firstName) {
    var attrs = { email: email, properties: { 'HF Signup Source': source } };
    if (firstName) attrs.first_name = firstName;
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: attrs
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    };
    return fetch(ENDPOINT, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    if (form.__hfKlaviyoSent) return;
    if (!isSignupForm(form)) return;

    var input = form.querySelector('input[name="contact[email]"]');
    var email = ((input && input.value) || '').trim();
    if (!email || email.indexOf('@') < 1) return;

    e.preventDefault();
    form.__hfKlaviyoSent = true;

    var source = sourceFor(form);
    var released = false;
    var release = function () {
      if (released) return;
      released = true;
      try { form.submit(); } catch (err) {}
    };

    /* Never let a slow or blocked Klaviyo call hold the signup hostage. */
    setTimeout(release, FAILSAFE_MS);

    try {
      subscribe(email, source).then(release, release);
    } catch (err) {
      release();
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'hf_signup_klaviyo', hf_signup_source: source });
    } catch (err) {}
  }, true);

  /* Email popup: subscribe alongside hitchfire.js's own handler (it prevents
     the default and swaps to the success panel), and stop the popup coming back. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-email-form]')) return;
    if (form.__hfKlaviyoSent) return;
    var em = form.querySelector('input[name="email"]');
    var fn = form.querySelector('input[name="first_name"]');
    var email = ((em && em.value) || '').trim();
    if (!email || email.indexOf('@') < 1) return;
    form.__hfKlaviyoSent = true;
    var source = 'Ebook popup';
    try { subscribe(email, source, ((fn && fn.value) || '').trim()).catch(function () {}); } catch (err) {}
    try { localStorage.setItem('hf-popup-dismissed', String(Date.now() + 3650 * 86400000)); } catch (err) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'hf_signup_klaviyo', hf_signup_source: source });
    } catch (err) {}
  }, true);
})();
